import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BookMarkService } from 'src/app/modules/map/services/Bookmark/book-mark.service';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css'],
})
export class DeleteModalComponent implements OnInit {
  delBookMark: any;
  delBody: any;
  mapId: any;
  eventName!: string;
  json: any;
  annotation_delete= {}
  constructor(
    private sideNavService: SideNavService,
    private dialog: MatDialog,
    public bookMarkService: BookMarkService,
    private mapService: MapServiceService,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.annotation_delete = this.mapService.getAllModals.annotation_delete
    }, 500);
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
  }

  close(): void {
    this.dialog.closeAll();
  }

  capitalizeFirstLetter(string: any) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  delete() {
    if (this.data.type === 'delete') {
      this.delBody = {
        annotation_ids: this.data.id,
        map_id: +this.mapId,
      };
      this.mapService.deleteAnnotation(this.delBody).subscribe((res) => {
        this.dialog.closeAll();
        this.delBookMark = res;
        if(res.annotations[0].type === 'geomcollection') {
          this.eventName =
          'Annotation:' +
          `Upload` +
          ':Delete';
        } else {
          this.eventName =
          'Annotation:' +
          `${this.capitalizeFirstLetter(res.annotations[0].type)}` +
          ':Delete';
        }
        this.json = {
          annotation_label: `${res.annotations[0].name}`,
          annotation_description: `${res.annotations[0].description}`,
        };
        this.json = JSON.stringify(this.json);
        this.activityLoging();
        for (let i = 0; i < res.annotations.length; i++) {
          this.sideNavService.deleteAnnotationComponent(res.annotations[i]);
        }
        this.sideNavService.closeRightSideNav();
      });
    } else if (this.data.type === 'bookMark') {
      this.delBody = {
        view_id: this.data.id,
        active_status: this.data.status,
      };
      this.bookMarkService.deletbookMark(this.delBody).subscribe((res) => {
        this.dialog.closeAll();
        this.delBookMark = res;
        this.eventName = 'Bookmark:Delete';
        this.json = {
          bookmark_label: `${this.delBookMark.bookmark.view_label}`,
        };
        this.json = JSON.stringify(this.json);
        this.activityLoging();
        this.sideNavService.deleteBookMarkComponent(
          (this.delBookMark = res.bookmark)
        );
      });
    } else if (this.data.type === 'folder_annotation_delete') {
      this.mapService.deleteAnnotationFolder(this.data.id).subscribe(
        () => {
          this.sideNavService.deleteAnnotationFolderComponent(this.data.id);
          this.dialog.closeAll();
        },
        () => {
          //
        }
      );
    } else if (this.data.type === 'deleteFolder') {
      this.delBody = {
        annotation_ids: this.data.id,
        map_id: +this.mapId,
      };
      this.mapService.deleteAnnotation(this.delBody).subscribe((res) => {
        for (let i = 0; i < res.annotations.length; i++) {
          res.annotations[i].subType = 'deleteFolder';

          this.sideNavService.deleteAnnotationComponent(res.annotations[i]);
        }
        this.dialog.closeAll();
        this.sideNavService.closeRightSideNav();
      });
    }
  }

  activityLoging() {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapId.toString(),
          event: 'Click',
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: this.eventName,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          event_information: this.json,
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }
}
